<section class="features">
  <h2 class="features__title">{{ 'crm_capabilities' | translate }}</h2>
  <div class="features__list">

    <!--    crm-->
    <div class="feature">
      <div class="img-wrapper">
        <img title="JECRM Lids" src="../../../../../assets/img/lids.png" alt="JECRM Lids" />
      </div>
      <div class="features-container">
        <h3 class="feature__title">CRM</h3>
        <ul class="feature__details">
          <li>{{ 'funnels_leads' | translate }}</li>
          <li>{{ 'creating_a_new_lead' | translate }}</li>
          <li>{{ 'custom_fields' | translate }}</li>
          <li>{{ 'contacts' | translate }}</li>
          <li>{{ 'managers_and_access_rights' | translate }}</li>
        </ul>
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <!--    chats-->
    <div class="feature">
      <div class="features-container">
        <h3 class="feature__title">{{ 'communication_channels' | translate }}</h3>
        <ul class="feature__details">
          <li>{{ 'chats.on_platforms' | translate }}</li>
          <li>{{ 'instant_communication' | translate }}</li>
          <li>{{ 'many_ad_chats' | translate }}</li>
          <li>{{ 'auto_replies_in_chat' | translate }}</li>
          <li>{{ 'quick_reply_templates' | translate }}</li>
          <li>{{ 'sending_images_in_chat' | translate }}</li>
          <li>{{ 'checking_if_a_message_has_been_read' | translate }}</li>
        </ul>
      </div>
      <div class="img-wrapper">
        <img title="JECRM Chats" src="../../../../../assets/img/chats.png" alt="Чати" />
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <!-- powerOLX   -->
    <div class="feature">
      <div class="img-wrapper">
        <img title="JECRM PowerOlx" src="../../../../../assets/img/powerOlx.png" alt="PowerOlx" />
      </div>
      <div class="features-container">
        <h3 class="feature__title">PowerOLX</h3>
        <span class="span">{{ 'boost_your_business' | translate }}.</span>
        <ul class="feature__details">
          <li>{{ 'schedule_activation' | translate }}</li>
          <li>{{ 'schedule_your_ads' | translate }}</li>
          <li>{{ 'edit_the_price' | translate }}</li>
        </ul>
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>


    <!--  TElEFONIA   -->
    <div class="feature">
      <div class="img-wrapper">
        <img title="JECRM Ringostat" src="../../../../../assets/img/ringostat.png" alt="Ringostat" />
      </div>
      <div class="features-container">
        <h3 class="feature__title">{{ 'telephony' | translate }}</h3>
        <span class="span">{{ 'ringostat_is_the_most' | translate }}.</span>
        <ul class="feature__details">
          <li>{{ 'state_of_the_art_telephony' | translate }}</li>
          <li>{{ 'call_administration' | translate }}</li>
          <li>{{ 'listening_and_downloading_conversations' | translate }}</li>
        </ul>
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <!--  TELEGRAM Bot -->
    <div class="feature">
      <div class="features-container">
        <h3 class="feature__title">{{ 'telegram_bot.title' | translate }}</h3>
        <ul class="feature__details">
          <li>{{ 'integration_with_telegram' | translate }}</li>
          <li>{{ 'duplicating_customer_request' | translate }}</li>
          <li>{{ 'duplicate_messages' | translate }}</li>
          <li><b>{{ 'connecting_personal_accounts' | translate }}</b></li>
        </ul>
      </div>
      <div class="img-wrapper">
        <img title="JECRM Telegram" src="../../../../../assets/img/tg.jpg" alt="Telegram" />
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <!--  JEX   -->
    <div class="feature">
      <div class="features-container">
        <h3 class="feature__title">JEX</h3>
        <span class="span">{{ 'reduce_the_number' | translate }}.</span>
        <ul class="feature__details">
          <li>{{ 'nova_poshta' | translate }}</li>
          <li>{{ 'ukrposhta' | translate }}</li>
          <li>{{ 'comment_on_the_shipment' | translate }}</li>
          <li>{{ 'status_control' | translate }}</li>
          <li>{{ 'notification_of_customers' | translate }}</li>
        </ul>
      </div>
      <div class="img-wrapper">
        <img title="JECRM JEX" src="../../../../../assets/img/jex.png" alt="JEX" />
      </div>
    </div>


  </div>
</section>
